module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAZCAYAAAArK+5dAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEYSURBVHgB7ZTdEYIwDMeL57sdgREYgRHcQEZgA9kANxAn0A3QCWADcALcIKaQ3vWkTSu++MDvLteH/slXE4RY+TsAIEYr0QaYaNAyRpujFWj7UOcd2Dl+aA8WjUpGcgHOwJMaibgouAA+TqTLGc1g+tyY7RF+dnRKRiOtAaIo6vF4CZ4nnXdG0zpvYJoGjtjQNg5NJjhQUId8CNNDV2bvbc4jRxAlVHMtqeQKW9g6tInWocbX4jBgvoyahm0RXkqYRvBK4o5aVur+k/MBeOYLp0oF9xZrSkoiAT+16TyFcMbsgF82Ter7/7goKLHOo6vHiYHvUW8QUsXALYwPlZj3LbZYaSKWEaPd0C6cSAV4iGX0tFiZWPmFN6HuhxF68W8WAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./app/images/administration-icon.png
// module id = 3843
// module chunks = 0